
import { useTranslation } from 'react-i18next';
import * as Vlab from 'vlab-frontend-components'

type OverviewProps = {
  total: number;
  total_comments: number;
  average: number;
  quantity1: number;
  quantity2: number;
  quantity3: number;
  quantity4: number;
  quantity5: number;
};

export default function Overview({
  total,
  total_comments,
  average,
  quantity1,
  quantity2,
  quantity3,
  quantity4,
  quantity5,
}: OverviewProps) {
  const { t } = useTranslation()

  const renderStars = (count: number, filled: number) => {
    const stars = [];
    for (let i = 1; i <= count; i++) {
      stars.push(
        <span 
          key={i}
          className={`text-lg ${i <= filled ? "text-[#0166FF]" : "text-[#DDE5EC]"}`}
        >
          ★
        </span>
      );
    }
    return <div className="flex">{stars}</div>;
  };

  const Separator = () => (
    <div
      className="w-full mx-auto"
      style={{
        border: '1px solid #F1F1F1',
        margin: '16px 0px',
      }}
    />
  );

  return (
    <div className="min-w-[200px] pr-8 lg:pr-0">
      <div className="mb-4">
        <p className="text-[14px] font-semibold leading-[120%] text-[#212121]">
          {t('appEnabled.overview')}
        </p>
      </div>
      <Separator />

      <div className="mb-4">
        <p className="text-[12px] font-normal leading-[120%] text-[#212121] mb-4">
          {t('appEnabled.totalRatings')}
        </p>
        <p className="text-[24px] font-semibold leading-[18px] text-[#0166FF]">
          {total}
        </p>
      </div>
      <Separator />

      <div className="mb-4">
        <p className="text-[12px] font-normal leading-[120%] text-[#212121] mb-4">
          {t('appEnabled.averageRatings')}
        </p>
        <div className="flex items-center gap-4 mb-4">
          <span className="text-[24px] font-semibold leading-[18px] text-[#0166FF]">
            {average.toFixed(2)}
          </span>
          {renderStars(5, Math.round(average))}
        </div>
        
        <div className="space-y-1">
          {[5, 4, 3, 2, 1].map((stars) => {
            const quantity = (() => {
              switch (stars) {
                case 5: return quantity5;
                case 4: return quantity4;
                case 3: return quantity3;
                case 2: return quantity2;
                case 1: return quantity1;
                default: return 0;
              }
            })();
            
            return (
              <div key={stars} className="flex items-center gap-2">
                <div className="flex">
                  {Array.from({ length: stars }).map((_, i) => (
                    <span key={i} className="text-xl text-[#D2D2D2]">★</span>
                  ))}
                </div>
                <span className="text-[12px] text-[#212121]">
                  {quantity} {t('appEnabled.reviews')}
                </span>
              </div>
            );
          })}
        </div>
      </div>
      <Separator />

      <div>
        <p className="text-[12px] font-normal leading-[120%] text-[#212121] mb-4">
          {t('appEnabled.ratingsWithComments')}
        </p>
        <p className="text-[24px] font-semibold leading-[18px] text-[#0166FF]">
          {total_comments}
        </p>
      </div>
    </div>
  );
}